module.exports = __webpack_public_path__ + "img/event_stamp_bg_complete.22ec38c.svg";